import { useEffect, useState } from "react"
import { Control, SettingsGroup } from "../../../Modules/General"

import FontModule from "../../../Modules/FontModule"
import VariableModule from "../../../Modules/VariableModule"
import DataListModal from "../../DataModals/DataListModal"
import * as Basic from "../../../Modules/BasicFields"

const wordCloudVariables = [
    {name:'Most frequent', key:'most-frequent', type:'W'},
]

export default function WordCloud( props )
{
    const dynoCfg = props.dynoCfg 
    const setDynoCfg = props.setDynoCfg

    const modalOpen = props.modalOpen
    const selected = props.selected
    const reset = props.reset

    const [ hashtag, setHashtag ] = useState(null)
    const [ font, setFont ] = useState(null)
    const [ votingRate, setVotingRate ] = useState(null)
    const [ textColor, setTextColor ] = useState(null)
    const [ variables, setVariables ] = useState(null)
    const [ list, setList ] = useState(null)
    const [ resetHashtag, setResetHashtag ] = useState(null)

    const [ showModal, setShowModal ] = useState(false)

    const requiredData = [
        hashtag,
        font,
        votingRate,
        textColor,
        variables,
        list,
        resetHashtag
    ]

    const cfgName = "echo_chambers_word_cloud_cfg"


    const reload = () => {
        let properties = dynoCfg.properties
        let cfg = properties[cfgName] || {}

        setFont( cfg.font || {})
        setHashtag( cfg.hashtag || "")
        setVotingRate( cfg.voting_rate || "one_per_user")
        setTextColor( cfg.text_color || { r: 0, g: 0, b: 0, a: 1.0 })
        setVariables( cfg.variables || {} )
        setList( cfg.list || [] )
        setResetHashtag( cfg.reset_hashtag || "")
    }

    useEffect( () => {
        reload()
    },[])

    useEffect( () => {

        if( requiredData.includes(null) )
        {
            return
        }
        
        let data = {}
        data.font = font 
        data.hashtag = hashtag
        data.voting_rate = votingRate 
        data.text_color = textColor
        data.variables = variables
        data.list = list
        data.reset_hashtag = resetHashtag


        let cfg = structuredClone(dynoCfg)
        cfg.properties[cfgName] = data
        setDynoCfg(cfg)
    },[ font, hashtag, variables, votingRate, textColor, list, votingRate, resetHashtag ])

    if( requiredData.includes(null) )
    {
        return <></>
    }

    return (
        <>
            <SettingsGroup name="Behaviour"> 
                <Basic.ButtonInput name="Edit voting list" onClick={e => setShowModal(true)}/>
                <Basic.StringInput name="Hashtag" value={hashtag} setValue={setHashtag} />
                <Basic.SelectInput name="Frequency per viewer" value={votingRate} setValue={setVotingRate} 
                                   options={[
                                        { label: "One time only", value: "one_per_user" },
                                        { label: "Once every 10 seconds", value: "one_every_10_seconds" },
                                        { label: "Once every minute", value: "one_every_minute" },
                                        { label: "Unlimited", value: "unlimited" },
                                   ]}
                /> 
            </SettingsGroup>
            <FontModule font={font} 
                        setFont={setFont}
                        selected={selected}
                        reset={reset}
            />
            <SettingsGroup name="Visual Customization">
                <Basic.ColorInput name="Color" value={textColor} setValue={setTextColor} />
            </SettingsGroup>
            <VariableModule variables={variables} 
                            setVariables={setVariables} 
                            variableList={wordCloudVariables}
                            reset={reset}
            />
            <SettingsGroup name="Remote Control">
                <Basic.StringInput name="Reset Hashtag" value={resetHashtag} setValue={setResetHashtag} />
            </SettingsGroup>

            <DataListModal modalTitle="Voting list"
                           showModal={showModal}
                           setShowModal={setShowModal}
                           modalOpen={modalOpen}
                           list={list}
                           setList={setList}
            />


        </>
    )
}
